<script setup lang="ts">
import { ref, computed } from "vue";

// import { useSignUpStore } from '';
import { useSignUpStore } from "@/store/sign_up";
import animationTop from "@/components/home/animationTop.vue";
import animationBottom from "@/components/home/animationBottom.vue";
import { useRouter, useRoute } from "vue-router";
import { useJobsStore } from "@/store/jobs";
import SnackbarComponent from "@/common/SnackbarComponent.vue";
//const runtimeConfig = useRuntimeConfig();
const store = useJobsStore();
const route = useRoute();
const router = useRouter();
onMounted(() => {
  store.fetchPosts();
});
const profileType = route.params.type;

const position = route.params.position;

// const appId = computed(() => {
//   return runtimeConfig.public.NUXT_MY_APP_ID;
// });
const appId = ref("tlet");

const signUpStore = useSignUpStore();
let storeOne = signUpStore.one;

const reviewstar1 = ref(5);
const items = ref(["founder", "investor", "worker"]);

const positionList = computed(() => {
  let arr = store.jobsPosts;
  let newArr = [];
  for (let i = 0; i < arr.length; i++) {
    newArr.push({
      title: arr[i].title,
      key: arr[i].title
        .toLowerCase()
        .replace(/ /g, "-")
        .replace(/[^\w-]+/g, ""),
    });
  }
  return newArr;
});

function checkProfileType() {
  if (profileType) {
    const foundIndex = items.value.findIndex(
      (item: any | any[]) => item === profileType
    );
    if (foundIndex !== -1) {
      storeOne.metadata.yourProfile = profileType;
    }
  }
}

checkProfileType();

function checkPosition() {
  if (position) {
    storeOne.metadata.positions = position;
  }
}
checkPosition();

function positionHide() {
  if (storeOne.metadata.yourProfile !== "worker") {
    storeOne.metadata.positions = "";
  }
}

const valid = ref(false);
const Regform = ref();

const firstNameRules = ref([(v: string) => !!v || "First name is required"]);

const lastNameRules = ref([(v: string) => !!v || "Last name is required"]);

const emailRules = ref([
  (v: string) => !!v || "E-mail is required",
  (v: string) => /.+@.+\..+/.test(v) || "E-mail must be valid",
]);

const phoneNumberRules = ref([
  (v: string) => !!v || "Phone number is required",
]);

const yourProfileRules = ref([
  (v: string) => !!v || "Your profile is required",
]);
const positionRules = ref([(v: string) => !!v || "Position is required"]);
const companyIndustryRules = ref([
  (v: string) => !!v || "Company industry is required",
]);

// const checkboxRules = ref([
//   (v: boolean) => !!v || "You must agree to continue!",
// ]);
let snackbar = ref({
  show: false,
  message: null,
  color: null,
  timeout: 0,
});
let dialog = ref(false);

async function submitForm() {
  try {
    const { valid } = await Regform.value.validate();
    if (valid) {
      let user = await signUpStore.save({ appId: appId.value });
      Regform.value.reset(); // Reset the form after successful submission
      // dialog.value = true;
      router.back();
      snackbar.value = {
        message: "You have Successfully submission",
        color: "success",
        show: true,
        timeout: 2000,
      };
      // router.go(-1)
      //  signUpStore.setOne()
    }
  } catch (error: any) {
    snackbar.value = {
      message: "error",
      color: "error",
      show: true,
      timeout: 2000,
    };
    console.log(error);
  }
}
</script>

<template>
  <div class="it-wrapper position-relative">
    <div class="banner-shape position-relative">
      <div class="it-banner position-relative bg-darkprimarygray">
        <animationTop class="position-relative" />
        <v-container class="position-relative z-index1">
          <!-- <v-col col="12" md="6">
              <div class="text-sm-start text-center">
                <h1
                  class="text-white text-h1 mb-8"
                  data-aos="fade-right"
                  data-aos-delay="200"
                  data-aos-duration="1000"
                >
                  Grow with Treelet Register now and watch
                  <VueWriter
                    :array="['your dreams take root']"
                    :repeat="Infinity"
                    class="text-white text-h1"
                    data-aos="fade-right"
                    data-aos-delay="200"
                    data-aos-duration="1000"
                  />
                </h1>
                <v-btn size="large" class="bg-white text-primary px-8" variant="flat">
                                    get started
                                </v-btn>
                <div class="mt-sm-16 mt-8">
                  <v-rating v-model="reviewstar1" hover density="compact" half-increments readonly
                                        color="warning" class="ml-n2"></v-rating>
                  <div class="mb-8 mt-5 pr-lg-16">
                                        <p class="pr-lg-16 text-body-1">It’s easy to set up and the support experience is the best and
                                            unparalleled
                                            comparatively.</p>
                                    </div>
                  <img src="/images/it/wise.png" alt="logo" />
                </div>
              </div>
            </v-col> -->
          <SnackbarComponent :snackbar="snackbar"></SnackbarComponent>
          <v-row
            class="justify-center position-relative"
            align="center"
            no-gutters
          >
            <v-col cols="12" md="7">
              <div class="banner-circle d-none d-lg-block">
                <img src="/images/it/banner-circle.png" class="op-04" alt="" />
              </div>

              <div class="banner-circle-line d-none d-lg-block">
                <img
                  src="/images/it/banner-circle-lines.png"
                  class="op-04"
                  alt=""
                />
              </div>
              <h4 class="text-h4 font-weight-bold mb-5 text-white text-left">
                Register with us
              </h4>
              <v-form class="banner-form" ref="Regform">
                <v-row class="text-left mb-1">
                  <v-col cols="12" sm="6" class="py-1">
                    <h4 class="mb-2">First name:</h4>
                    <v-text-field
                      v-model="storeOne.firstName"
                      :rules="firstNameRules"
                      required
                      variant="solo"
                      density="compact"
                      color="primary"
                      elevation="0"
                    />
                  </v-col>

                  <v-col cols="12" sm="6" class="py-1">
                    <h4 class="mb-2">Last name:</h4>
                    <v-text-field
                      v-model="storeOne.lastName"
                      :rules="lastNameRules"
                      required
                      variant="solo"
                      density="compact"
                      color="primary"
                    />
                  </v-col>
                </v-row>
                <v-row class="text-left mt-1 mb-1">
                  <v-col cols="12" sm="6" class="py-1">
                    <h4 class="mb-2">Email:</h4>
                    <v-text-field
                      v-model="storeOne.email"
                      :rules="emailRules"
                      required
                      variant="solo"
                      density="compact"
                      color="primary"
                    />
                  </v-col>

                  <v-col cols="12" sm="6" class="py-1">
                    <h4 class="mb-2">Phone number:</h4>
                    <v-text-field
                      v-model="storeOne.phoneNumber"
                      :rules="phoneNumberRules"
                      required
                      variant="solo"
                      density="compact"
                      color="primary"
                    />
                  </v-col>
                </v-row>
                <v-row class="text-left mt-1 mb-1">
                  <v-col cols="12" sm="12" class="py-1"
                    ><h4>Your Profile:</h4></v-col
                  >
                  <v-col cols="12" sm="12" class="py-1">
                    <v-select
                      v-model="storeOne.metadata.yourProfile"
                      :rules="yourProfileRules"
                      required
                      variant="solo"
                      density="compact"
                      color="primary"
                      :items="items"
                      @update:modelValue="positionHide()"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row
                  class="text-left mt-1 mb-1"
                  v-if="storeOne.metadata.yourProfile == 'worker'"
                >
                  <v-col cols="12" sm="12" class="py-1"
                    ><h4>Position:</h4></v-col
                  >
                  <v-col cols="12" sm="12" class="py-1">
                    <v-select
                      v-model="storeOne.metadata.positions"
                      :rules="
                        storeOne.metadata.yourProfile == 'worker'
                          ? positionRules
                          : []
                      "
                      item-value="key"
                      item-title="title"
                      variant="solo"
                      density="compact"
                      color="primary"
                      :items="positionList"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row no-gutters class="text-left mt-1">
                  <v-col cols="12" sm="12" class="py-1"
                    ><h4>Application:</h4>
                  </v-col>

                  <v-col cols="12" sm="12" class="py-1">
                    <v-textarea
                      v-model="storeOne.metadata.companyIndustry"
                      :rules="companyIndustryRules"
                      required
                      variant="solo"
                      auto-grow
                      density="compact"
                      rows="5"
                      color="primary"
                      row-height="40"
                    />
                  </v-col>
                </v-row>
                <v-col cols="12">
                  <div class="ml-n2">
                    <div class="d-flex align-center agree">
                      <v-checkbox
                        class="text-white pt-5"
                        v-model="storeOne.metadata.termsAndConditions"
                        required
                      ></v-checkbox>
                      <div>
                        I have read and acknowledge the
                        <NuxtLink to="/" class="opacity-1 text-white">
                          Terms and Conditions</NuxtLink
                        >
                      </div>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" class="pt-0">
                  <v-btn
                    class="bg-warning"
                    variant="flat"
                    size="large"
                    block
                    @click="submitForm"
                    >Submit
                  </v-btn>
                </v-col>
              </v-form>
            </v-col>
          </v-row>
        </v-container>

        <v-dialog v-model="dialog" width="auto">
          <v-card width="500">
            <div class="align-center pa-5">
              <h1>You've made it!</h1>
              <h3 class="mt-4">Your registration with Treelet is submitted.</h3>
            </div>

            <!-- <v-toolbar title="Your registration with Treelet is submitted." class="text-h1"></v-toolbar> -->
            <template v-slot:actions>
              <v-btn
                color="primary"
                class="ms-3 sticky-border d-lg-flex d-none"
                size="large"
                text="Ok"
                @click="dialog = false"
                variant="flat"
              ></v-btn>
            </template>
          </v-card>
        </v-dialog>
      </div>
    </div>
  </div>
  <div class="position-relative"><animationBottom /></div>
</template>
<style>
.banner-form .v-messages__message {
  font-size: 16px !important;
  color: yellow !important;
}
</style>